import React from 'react'
import Container from 'react-bootstrap/Container';
import Header from "../sections/Header/Header"
import Footer from "../sections/Footer"

export default function About(props){
    return(
        <div id="landing">
            <Header/>
        <div className="about page">
            <Container>
            <h1>درباره دیداری</h1>
            <h2>در دیداری برای زیستنی مطلوبتر تلاش می کنیم.</h2>
            <p>در یک ارتباط امن و به هنگام، پیام های ارزشمند شما را واضح به دیگران انتقال می دهیم.</p>
            <p>در خلال روزهای سخت فراگیر شدن بیماری کرونا در کشور و محدودیت های حضور و فعالیت در همه عرصه های زندگی کاری و شخصی، با بررسی نیازها و کمبودهای جدید پیش آمده تصمیم به طراحی و راه اندازی پلتفرمی ساده جهت تسهیل و کمک در برگزاری کلاسها، جلسات ، آموزشها، کنفرانسها و دورهمیها بر بستر وب و بصورت زنده و غیر حضوری گرفتیم.</p>
            <p> امیدواریم همه آنچه برای ارتباط های غیر حضوری شما فراهم ساخته ایم بتواند لحظات بودن و زندگیهامان را ملموس تر و دنیایی بهتر را شکل دهد.</p>
            </Container>
        </div>
        <Footer/>
        </div>
    )
}